exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n", ""]);

// exports
